/**
 * Tip selector — percentage buttons + custom dollar input
 */

import { Button, Input } from '@/components/ui'
import { formatPrice } from '@/utils/formatting'

const TIP_OPTIONS = [
  { label: 'No tip', value: 0 },
  { label: '10%', value: 10 },
  { label: '15%', value: 15 },
  { label: '18%', value: 18 },
  { label: '20%', value: 20 },
]

interface TipSelectorProps {
  subtotal: number
  tipPercent: number | 'custom'
  customTipInput: string
  onTipPercentChange: (value: number | 'custom') => void
  onCustomTipInputChange: (value: string) => void
  tipAmount: number
  currency?: string
}

export function TipSelector({
  tipPercent,
  customTipInput,
  onTipPercentChange,
  onCustomTipInputChange,
  tipAmount,
  currency,
}: TipSelectorProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-base font-semibold">Add a tip</h3>
      <div className="flex flex-wrap gap-2">
        {TIP_OPTIONS.map((opt) => (
          <Button
            key={opt.value}
            variant={tipPercent === opt.value ? 'black' : 'outline'}
            className="px-4 py-2.5 h-auto rounded-full text-sm"
            onClick={() => {
              onTipPercentChange(opt.value)
              onCustomTipInputChange('')
            }}
          >
            {opt.label}
          </Button>
        ))}
        <Button
          variant={tipPercent === 'custom' ? 'black' : 'outline'}
          className="px-4 py-2.5 h-auto rounded-full text-sm"
          onClick={() => onTipPercentChange('custom')}
        >
          Custom
        </Button>
      </div>
      {tipPercent === 'custom' && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">{currency === 'EUR' ? '€' : currency === 'GBP' ? '£' : '$'}</span>
          <Input
            type="number"
            min={0}
            max={999}
            step={0.01}
            placeholder="0.00"
            value={customTipInput}
            onChange={(e) => {
              const val = e.target.value
              if (val === '' || (Number(val) >= 0 && Number(val) <= 999)) {
                onCustomTipInputChange(val)
              }
            }}
            className="w-28 h-9"
          />
        </div>
      )}
      {tipAmount > 0 && (
        <p className="text-xs text-muted-foreground">
          Tip: {formatPrice(tipAmount, currency)} — thank you!
        </p>
      )}
    </div>
  )
}
